import { memo } from "react";

import { modules } from "byzantine";

import styles from "../../SearchBar.module.scss";

import {
  AccountsResults,
  RecentSearchesResults,
  TransactionsResults,
} from "./SearchBarResults.Sections";

const { useIsGlobalSearchEnabled } = modules.search;

const SearchBarResults = () => {
  const { enabledSearchEntities } = useIsGlobalSearchEnabled();
  // To-do: display relevant sections based on search state and results
  // https://linear.app/narmi/issue/CDB-4769/fe-create-useglobalsearch-to-provide-search-results-to-component
  return (
    <div className={styles["results-section-container"]}>
      <RecentSearchesResults />
      {enabledSearchEntities.transactions && <TransactionsResults />}
      {enabledSearchEntities.accounts && <AccountsResults />}
    </div>
  );
};

export default memo(SearchBarResults);
